import GraphqlBuilder, { graphqlOptions } from "utils/request/graphql/builder";
import _ from "lodash";
import { createTranslationMutationParameters } from 'components/molecules/Form'
import MutationTranslation from 'graphql/mutations/MutationTranslation'

const MutateTranslation = {
	
	mutate: ( table, guid, values, { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		// Create the translation parameters
		const parameters = createTranslationMutationParameters( values );
		const guids = _.isArray( guid ) ? guid : [ guid ];
		
		const builder = new GraphqlBuilder({
			[ graphqlOptions.processVariables ]: false
		});

		_.forEach( guids, _guid => {
			_.forEach( parameters, variables => {
				builder.addQuery( `mutation_translation_${table}_${_guid}_${ variables.field }_${ variables.language_code }`, MutationTranslation, {
					...variables,
					table: table,
					table_key: _guid
				} );
			});
		})
		
		builder.setOnStart( callbackStart )
		builder.setOnSuccess( ( result ) => {
			MutateTranslation.onSuccess( result, callbackSuccess );
		});
		builder.setOnError( (result) => {
			MutateTranslation.onSuccess( result, callbackError );
		} );
		
		if( builder.queries.length > 0 ) {
			builder.execute();
			return;
		}
		
		MutateTranslation.onSuccess( {}, callbackSuccess );
	},
	
	/**
	 *
	 * @param result
	 * @param callback
	 */
	onSuccess: ( result, callback ) => {
		const results = [];
		_.forEach( result, o => {
			results.push( o.translation );
		})
		
		if( _.isFunction( callback ) ) {
			callback( results );
		}
	},
	
	/**
	 *
	 * @param result
	 * @param callback
	 */
	onError: ( result, callback ) => {
		if( _.isFunction( callback ) ) {
			callback( result );
		}
	},
}

export default MutateTranslation
